import { stripTkMarkers } from '@ws/shared/utils';

/**
 * Извлекает текст из HTML и подсчитывает длину в символах и словах
 * @param {string} html - HTML-строка заметки
 * @returns {Object} - { chars: number, words: number }
 */
export function getTextLengthFromHtml(html: string) {
  // Создаём временный DOM-элемент для парсинга HTML
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  // TK-метки — не финальный текст, в статистику они не входят.
  // Изымаются только метки с валидным литералом: битый span считается прозой.
  stripTkMarkers(doc.body);

  // Извлекаем текст из body, убираем лишние пробелы
  const text = doc.body.textContent?.trim();

  if (!text) {
    return {
      chars: 0,
      words: 0,
    };
  }

  return getLengthFromText(text);
}

export function getLengthFromText(text: string) {
  // Подсчитываем символы (без пробелов и переносов строк)
  // const charCount = text.replace(/\s+/g, '').length;
  const charCount = text.length;

  // Подсчитываем слова (разделяем по пробелам, фильтруем пустые)
  const wordCount = text.split(/\s+/).filter((word) => word.length > 0).length;

  return {
    chars: charCount,
    words: wordCount,
  };
}
